import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { DriverDayOffFilterEntity } from '../../domain/entities/DriverDayOffFilterEntity'

export class DriverDayOffFilterModel extends DriverDayOffFilterEntity {
  driverId?: number
  regionId?: number

  constructor(dataDto: DriverDayOffFilterEntity) {
    super()
    mapEntityProperties<DriverDayOffFilterModel>(this, dataDto, {
      exclude: ['driver', 'region'],
      map: {
        driverId: dataDto.driver?.id,
        regionId: dataDto.region?.id
      }
    })
  }
}
